<template>
<v-container fluid class="pa-5">
  <!-- <view-header title="Drivers" :description="`Manage the Drivers from this CMS portal.`" :icon="'mdi-steering'"/> -->
  <generic-data-table 
        :items="entities['driver']" 
        :loading="false" 
        :headers="headers" 
        :search="search"
        :show_excel="true"
        :show_print="true"
        entity_name="driver"
        :localizable_fields="localizable_fields"
        :hideAddButton="hideAddButton"
        :allowEdit="allowEdit"
        :showCardView="true"
        :driver_id="driver !== undefined? current_entity[entity_name].id : undefined"
        @add="saveEntity(null)"
        @rowClick="row => saveEntity(row)"
      >
    </generic-data-table>
    <driver-details
      v-model="driverDetailsShown"
      v-if="driverDetailsShown"
      :headers="headers"
      :localizable_fields="localizable_fields"
      entity_name="driver"
      title="Drivers"
      :driver="driver"
    >
    </driver-details>
</v-container>
</template>

<script>
import GenericDataTable from '@/components/GenericDataTable'
import DriverDetails from '../components/driver/DriverDetails'
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return  {
      userRoleId:localStorage.getItem("UserRoleId"),
      driverDetailsShown:false,
      search:"",
      entity_name:"driver",
      hideAddButton:false,
      allowEdit:true
    }
  },
  computed:{
    ...mapState('static',['genders','blood_types']),
    ...mapState('users',['loggedIn','user']),
    ...mapState('entities',['current_entity','entities','loading','selected_search_entity']),
    driver(){
      return this.current_entity['driver']
    },
    headers(){
      return [ 
            {
                text: 'Email',
                value: 'email',
                type: 'textfield',
                autogenerated:true,
                localizedGenerateField:"firstName"
            },
            {
                text: 'Phone',
                value:'mainPhoneNumber',
                type: 'textfield',
            },
            {
                text: 'Profile Image',
                value: 'profileImage',
                type: 'media_gallery',
                media_type:1,
                userId : 0,
            },
            {
                text: 'Driver\'s License',
                value: 'id',
                type: 'media_gallery',
                media_type:6,
                userId : 0,
                hide_in_table:true
            },
            {
                text: 'Truck Registration Card',
                value: 'id',
                type: 'media_gallery',
                media_type:7,
                userId : 0,
                hide_in_table:true
            },
            {
                text: 'Insurance Policy',
                value: 'id',
                type: 'media_gallery',
                media_type:8,
                userId : 0,
                hide_in_table:true
            },
            {
                text: 'Gender',
                value: 'idGender',
                type: 'radio',
                options: this.genders
            },
            {
              text:"Date Of Birth",
              value:"dateOfBirth",
              type:'date',
              hide_in_table:true
            },
            {
              text:"DOB",
              value:"strDateOfBirth",
              type:'textfield',
              not_editable:true
            },
            {
                text: 'Blood Type',
                value: 'idBloodType',
                type: 'select',
                options:this.blood_types
            },
            {
                text: 'Rating(1-5)',
                value: 'rating',
                type: 'textfield'
            },
            {
                text: 'Password',
                value: 'password',
                type: 'textfield',
                hide_in_table:true,
                autogenerated:'123456'
            },
            // {
            //   text:"Email Verified",
            //   value: "emailVerified",
            //   type:'checkbox'
            // },
            {
              text:"Send to ff",
              type:"freight",
              url:"driver/shareByEmail"
            }
            // {
            //   text: "Mobile Phones",
            //   value: "phones",
            //   type:'mobile_phone',
            // }
        ]
      },

      localizable_fields() {
        return [
            {
                text: 'First Name',
                value: 'firstName',
                type: 'textfield'
            },
            {
                text: 'Last Name',
                value: 'lastName',
                type: 'textfield'
            }
        ]   
      }  
  },
  components: {
    GenericDataTable,DriverDetails
  },
  methods: {
    ...mapActions('entities',['getEntities','saveEntity']),
    saveEntity(entity) {       
      if(entity !== null) {
        this.current_entity[this.entity_name] = entity 
      }
      else {
        //reset the search
        this.selected_search_entity['driver'] = {}
      }          
        // Add the component back in
      this.driverDetailsShown = true; 
      this.getEntities('driver'); 
         
    }
  },
  mounted(){ 
    this.getEntities('driver'); 
    this.hideAddButton = (this.userRoleId==3);
    this.allowEdit = !(this.userRoleId==3);
  }
}
</script>